<template>
    <li v-bind:class="{ active: group.selected }"><div v-on:click="toggleShow" class="color" v-bind:style="{backgroundColor: group.color}"><span v-show="group.show">✔</span></div> <a v-on:click="toggleSelected" href="#">{{group.name}}({{group.count}})</a></li>
</template>

<script>
    export default {
        name: "GroupItem",
        props:{
            group: Object,
            toggleGroup: Function,
            toggleGroupShow: Function
        },
        methods:{
            toggleSelected: function (){
                this.toggleGroup(this.group);
            },
            toggleShow: function (){
                this.toggleGroupShow(this.group);
            }
        }
    }
</script>

<style scoped>
    .color span{
        padding: 0;
        margin: 0;
    }

    .color{
        display: inline-block;
        border: 1px solid #ffffff;
        width: 1rem;
        height: 1rem;
        background-color: #EEEEEE;
        margin-right: 0.2rem;
        box-shadow: 1px 1px 0px #425360;
        font-size: 0.7rem;
        color: #ffffff;
        text-align: center;
        cursor: default;
    }

    li{
        display: flex;
    }

    .legend ul li a{
        color: #ffffff;
    }

    .legend ul li.active a{
        text-decoration: none;
    }
</style>
